import { ToastTemplatesComponent } from '@app/shared/toast/components/toast-templates/toast-templates.component';

export const components = [ToastTemplatesComponent];

export * from '@app/shared/toast/components/toast-templates/toast-templates.component';
